import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import { dispatchInAppToast } from '../components/InAppToast';

// PC 웹 전용 — 브라우저 푸시 권한과 무관하게 Firestore notifications를 직접 구독해
// 내(mcode)에게 온 새 알림을 하단 인앱 토스트 + 풀잎 알림음으로 띄운다.
// (모바일 RN 앱은 네이티브 푸시가 처리하므로 호출하지 않음)

let unsub = null;

const tsToMillis = (ts) => {
  if (!ts) return 0;
  if (ts.toMillis) return ts.toMillis();
  if (ts.seconds != null) return ts.seconds * 1000;
  const d = new Date(ts);
  return isNaN(d.getTime()) ? 0 : d.getTime();
};

export const startNotificationToastListener = (mcode) => {
  if (unsub || !mcode || typeof window === 'undefined') return;
  const sinceMs = Date.now(); // 로그인 이후 생성된 알림만 토스트 (과거 알림 토스트 방지)
  try {
    const q = query(
      collection(db, 'notifications'),
      where('targetUids', 'array-contains', String(mcode)),
      orderBy('createdAt', 'desc'),
      limit(25)
    );
    unsub = onSnapshot(
      q,
      (snap) => {
        snap.docChanges().forEach((ch) => {
          if (ch.type !== 'added') return;
          const d = ch.doc.data() || {};
          if (tsToMillis(d.createdAt) < sinceMs) return; // 기존(과거) 알림 무시
          dispatchInAppToast({
            notiId: ch.doc.id,
            title: d.title || '풀잎하우스',
            body: d.body || '',
            type: d.type || '',
            data: d.data || {},
          });
        });
      },
      (err) => console.warn('[NotiToast] 구독 실패:', err?.message || err)
    );
  } catch (e) {
    console.warn('[NotiToast] 시작 실패:', e?.message || e);
  }
};

export const stopNotificationToastListener = () => {
  if (unsub) {
    try { unsub(); } catch {}
    unsub = null;
  }
};
